import * as Colors from '../../colors'

export const colors = [
  Colors.cyan300,
  Colors.cyan400,
  Colors.cyan500,
  Colors.cyan600,
  Colors.grey400,
  Colors.grey500,
  Colors.grey600,
  Colors.grey700,
  Colors.grey800,
  Colors.grey900,
  Colors.red300,
  Colors.red400,
  Colors.red500,
  Colors.red600,
  Colors.red700,
  Colors.yellow300,
  Colors.yellow400,
  Colors.yellow500,
  Colors.green300,
  Colors.green400,
  Colors.green500,
]



// WEBPACK FOOTER //
// ./src/components/word-cloud/constants.ts